import { PackageOpen } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface NoDataProps {
  className?: string
  message?: string
}

export function NoData({ className, message }: NoDataProps) {
  const { t } = useTranslation()
  return (
    <div className={cn('flex flex-col items-center justify-center py-12 text-muted-foreground', className)}>
      <PackageOpen className="h-16 w-16 mb-4 opacity-50" />
      <p className="text-sm">{message || t('public.noData')}</p>
    </div>
  )
}
